import { DevicesActionTypes, ActionDevicesDeleteSuccess } from './../devices/devices.reducer';
import { Injectable, inject } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ManageService } from '@app/certificates/manage/manage.service';
import {
    ManageCertificateActionTypes,
    ActionError,
    ActionCertificatesInitialize
} from '@app/certificates/manage/manage.reducer';
import { switchMap, map } from 'rxjs/operators';
import { ISpringResponseBody } from '@app/shared/interfaces/response-interfaces';

@Injectable()
export class ManageCertificateEffects {

    private actions$ = inject(Actions<Action>)
    private manageService = inject(ManageService)   

    get$ = createEffect(() => {
        return this.actions$
            .pipe(ofType(ManageCertificateActionTypes.GET),
                switchMap(() => {
                    return this.manageService.getAll();
                }),
                map((response: ISpringResponseBody) => {
                    if (response.status === 200) {
                        return new ActionCertificatesInitialize({ certificates: response.data });
                    } else {
                        return new ActionError({ response });
                    }
                })
            )
    }, { dispatch: true });

    operationFailed$ = createEffect(() => {
        return this.actions$.pipe(ofType(ManageCertificateActionTypes.ERROR));
    }, { dispatch: false })


    deleteDevices$ = createEffect(() => {
        return this.actions$.pipe(ofType(DevicesActionTypes.DELETE_SUCCESS));
    }, { dispatch: false })

}
